import React from "react";
import {
	IconCalendarOutline,
	IconChatbubblesOutline,
	IconFlashOutline,
	IconNoDocument,
	IconNoPayment,
	IconPrescription,
	IconStar,
	IconLockClosedOutline,
	IconShieldCheckmarkOutline,
	IconVideocamOutline,
	IconLocationSharpOutline,
	IconSmilePeaceOutline,
	IconPlantsGrowthOutline,
	IconHeartHandsOutline,
	IconNote,
	IconCirclesInCircle,
	IconSecurityCheck,
	IconLocationSharp,
	IconInsurance,
	IconMyProvider,
	IconPeople,
	IconPeopleOutline,
	IconLockClosed,
	IconAddProvider,
	IconDesktopMobile,
	IconBookSharp,
	IconTimelineChatBookings,
	IconUserInfo,
	IconScreenOff,
	IconDocumentAttach,
} from "@atoms/Icon/list";

import { IoMdCheckmark } from "react-icons/io";

interface Props {
	icon: string;
}

const GenericIcon: React.FC<Props> = ({ icon }) => {
	const mapIcon = () => {
		switch (icon) {
			case "IconDocumentAttach":
				return <IconDocumentAttach />;
			case "IconScreenOff":
				return <IconScreenOff />;
			case "IconUserInfo":
				return <IconUserInfo />;
			case "IconTimelineChatBookings":
				return <IconTimelineChatBookings />;
			case "IconPeople":
				return <IconPeople />;
			case "IconPeopleOutline":
				return <IconPeopleOutline />;
			case "IconLockClosed":
				return <IconLockClosed />;
			case "IconAddProvider":
				return <IconAddProvider />;
			case "IconDesktopMobile":
				return <IconDesktopMobile />;
			case "IconBookSharp":
				return <IconBookSharp />;
			case "IconMyProvider":
				return <IconMyProvider />;
			case "IconSecurityCheck":
				return <IconSecurityCheck />;
			case "IconLocationSharp":
				return <IconLocationSharp />;
			case "IconInsurance":
				return <IconInsurance />;
			case "IconCheck":
				return <IoMdCheckmark />;
			case "IconCirclesInCircle":
				return <IconCirclesInCircle />;
			case "IconNote":
				return <IconNote />;
			case "IconSmilePeaceOutline":
				return <IconSmilePeaceOutline />;
			case "IconPlantsGrowthOutline":
				return <IconPlantsGrowthOutline />;
			case "IconHeartHandsOutline":
				return <IconHeartHandsOutline />;
			case "location_sharp":
				return <IconLocationSharpOutline />;
			case "calendar_outline":
				return <IconCalendarOutline />;
			case "chat_bubble_outline":
				return <IconChatbubblesOutline />;
			case "flash_outline":
				return <IconFlashOutline />;
			case "no_document_outline":
				return <IconNoDocument />;
			case "no_payment_outline":
				return <IconNoPayment />;
			case "document_check_outline":
				return <IconPrescription />;
			case "star_outline":
				return <IconStar />;
			case "lock_closed_outline":
				return <IconLockClosedOutline />;
			case "shield_outline":
				return <IconShieldCheckmarkOutline />;
			case "camera_outline":
				return <IconVideocamOutline />;
			default:
				return <></>;
		}
	};

	return mapIcon();
};
export default GenericIcon;
